var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.uniqueAudio),function(audio){return _c('audio',{key:'audio-' + audio,ref:audio,refInFor:true,attrs:{"src":audio}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }